import {Component, OnInit, Input} from '@angular/core';
import {TransactionsService} from './transactions.service';

@Component({
    selector: 'details-for-supplier',
    templateUrl: './templates/details-for-supplier.component.html',
    styleUrls: ['./styles/details-for-supplier.component.css'],
    providers: [TransactionsService]
})
export class DetailsForSupplierComponent implements OnInit {
    brlf_details: Array<any> = [];
    @Input() purchase_order: any = [];

    constructor(private transactions_service: TransactionsService) {}

    ngOnInit() {
    }

    ShowInfos(brlf: any): void {
        console.log(brlf);
        let id_purchase_order = brlf.id_purchase_order;
        this.transactions_service.GetPurchaseOrdersDetails(id_purchase_order).then(result => {console.log(result['list']); this.brlf_details = result['list']; console.log(this.brlf_details)});
    }

    ngOnChanges() {


    }


}



// WEBPACK FOOTER //
// ./src/app/details-for-supplier.component.ts